export const tagsFilterDropdownMotionDurationMs = 190;

export const buildTagsFilterDropdownPaperMotionSx = (
  isClosing: boolean,
): Record<string, unknown> => ({
  pointerEvents: isClosing ? 'none' : 'auto',
  opacity: isClosing ? undefined : 1,
  transform: isClosing ? undefined : 'translateY(0) scaleY(1)',
  transformOrigin: 'top center',
  animation: isClosing
    ? `flowqaFilterMenuShrink ${String(tagsFilterDropdownMotionDurationMs)}ms cubic-bezier(0.4, 0, 1, 1)`
    : `flowqaFilterMenuGrow ${String(tagsFilterDropdownMotionDurationMs)}ms cubic-bezier(0.2, 0, 0, 1)`,
  '@keyframes flowqaFilterMenuGrow': {
    from: {
      opacity: 0,
      transform: 'translateY(-4px) scaleY(0.82)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0) scaleY(1)',
    },
  },
  '@keyframes flowqaFilterMenuShrink': {
    from: {
      opacity: 1,
      transform: 'translateY(0) scaleY(1)',
    },
    to: {
      opacity: 0,
      transform: 'translateY(-4px) scaleY(0.82)',
    },
  },
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
});
